export default {"src":"/_next/static/media/youtube.90526974.svg","height":192,"width":192};